var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarStationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9095 10.7209H14.8195V3.52087C14.8195 1.84087 13.9095 1.50087 12.7995 2.76087L11.9995 3.67087L5.22952 11.3709C4.29952 12.4209 4.68952 13.2809 6.08952 13.2809H9.17952V20.4809C9.17952 22.1609 10.0895 22.5009 11.1995 21.2409L11.9995 20.3309L18.7695 12.6309C19.6995 11.5809 19.3095 10.7209 17.9095 10.7209Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarStationActive);
export default __webpack_public_path__ + "static/media/sidebar-station-active.e7fd14b47feb226d9ce832f6fb988a11.svg";
export { ForwardRef as ReactComponent };